// Global reveal animations via IntersectionObserver
$(document).ready(function () {
	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add("revealed");
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
	);

	document
		.querySelectorAll(
			[
				// Home
				".home-service-grid .service-card",
				".home-product-grid .product-card",
				".home-service-header",
				".home-product-header",
				".edu-item",
				".edu-bg",
				".introduce-section",
				".introduce-card",
				// Contact
				".contact-info-card",
				".contact-form-section",
				".contact-hero",
				".contact-container",
				// Service
				".service-card",
				".service-hero",
				".service-grid-header",
				// Product
				".product-card",
				".product-hero",
				".product-grid-header",
				// About
				".about-content-card",
				".stories-card",
				".team-card",
				".faq-accordion-item",
			].join(", ")
		)
		.forEach(function (el) {
			el.classList.add("reveal");
			observer.observe(el);
		});
});
